// src/api/feedback.js
import { LOCAL_API_URL, http } from '@/api/base'

/**
 * 提交用户评价
 */
export function submitFeedback(feedbackData) {
  console.log(feedbackData);
  return http.post(
     `${LOCAL_API_URL}/aics/conversation_feedback/submit`, 
     feedbackData
    );
}

/**
 * 获取对话评价
 */
export function loadFeedbackData(workspaceSlug, threadSlug) {
  return http.get(`/aics/conversation_feedback/details?workspace_slug=${workspaceSlug}&thread_slug=${threadSlug}`);
}

/**
 * 获取AI坐席评价统计
 */
export function getAiSeatStatistics(aiSeatId, startDate, endDate) {
  const params = {};
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  
  return http.get(`/api/feedback/statistics/ai-seat/${aiSeatId}`, { params });
}